import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { documentsApi } from '@/domain/documents/api';
import type { DocumentSubtype } from '@/domain/documents/schemas';
import { queryOptions } from '@/services/query';

import { documentsKeys } from '@/domain/documents/queries/keys';

export const documentSubtypesQuery = (companyId: string) =>
  queryOptions({
    // The request is scoped by the CompanyId header; companyId here only keeps
    // each company's cache separate.
    queryKey: documentsKeys.subtypes(companyId),
    queryFn: () => documentsApi.getSubtypes(),
    staleTime: 60 * 60 * 1000, // reference data, rarely changes
    select: (data): DocumentSubtype[] => data.subtypes,
  });

// Not role-gated: read-only screens need the sub-type labels too. Screens that
// reclassify check `IS_ACCOUNT` themselves.
export const useDocumentSubtypes = () => {
  const { companyId } = useParams();
  return useQuery({
    ...documentSubtypesQuery(companyId ?? ''),
    enabled: Boolean(companyId),
  });
};
